import React from 'react';
import PropTypes from 'prop-types';

import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

export function SiteRecordsDetails({ details }) {
  const { about } = details;
  const {
    lastRecordedRealEstatePropertyTaxYear,
    fireInsuranceClassRating,
    lastRecordedRealEstateTaxValue,
    taxValue,
    taxRate,
    taxPer,
  } = about;

  if ((lastRecordedRealEstatePropertyTaxYear && lastRecordedRealEstateTaxValue)
  || fireInsuranceClassRating) {
    return (<section>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">Records</h4>
      </ViewerPrimaryColorUserStyle>
      <div className="section-body">
        <ul>
          {parseFloat(lastRecordedRealEstateTaxValue).toFixed(2) !== 'NaN' &&
            <li>
              <strong>Last Property Taxes: </strong>
              {lastRecordedRealEstatePropertyTaxYear} - $
              {parseFloat(lastRecordedRealEstateTaxValue).toFixed(2)}
            </li>
          }
          {taxValue && (<li><strong>Tax Value: </strong>{taxValue}</li>)}
          {taxRate && (<li><strong>Tax Rate: </strong>{taxRate}</li>)}
          {taxPer && (<li><strong>Tax Per: </strong>{taxPer}</li>)}
          {fireInsuranceClassRating && (
            <li><strong>Fire insurance class rating: </strong>{fireInsuranceClassRating}</li>
          )}
        </ul>
      </div>
    </section>);
  }

  return (<section />);
}

SiteRecordsDetails.propTypes = {
  details: PropTypes.object.isRequired,
};

export default SiteRecordsDetails;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailAdditional/AdditionalDetails/SiteRecordsDetails.js